import React from 'react';
import { Button } from '../ui/button';
import { Calendar, MessageCircle } from 'lucide-react';
import { heroContent, LINKS } from '../../data/mock';

const HeroSection = () => {
  return (
    <section className="relative min-h-screen flex items-center justify-center px-4 py-16 md:py-24 overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://images.unsplash.com/photo-1629909613654-28e377c37b09?auto=format&fit=crop&w=1920&q=80"
          alt="Clínica dental moderna"
          className="w-full h-full object-cover" />

        <div className="absolute inset-0 bg-gradient-to-b from-white/95 via-white/90 to-white/95"></div>
      </div>

      {/* Decorative Elements */}
      <div className="absolute top-20 left-10 w-72 h-72 bg-blue-400/10 rounded-full blur-3xl"></div>
      <div className="absolute bottom-20 right-10 w-96 h-96 bg-green-400/10 rounded-full blur-3xl"></div>

      <div className="relative z-10 max-w-5xl !text-center mx-auto">
        {/* Badge */}
        <div className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-white/80 backdrop-blur-sm border border-blue-100 text-[#007AFF] text-sm font-semibold mb-8 animate-fade-in shadow-lg shadow-blue-500/10">
          <span className="w-2.5 h-2.5 bg-[#007AFF] rounded-full animate-pulse"></span>
          Para Clínicas Dentales
        </div>

        {/* Headline */}
        <h1 className="md:text-5xl lg:text-6xl !font-extrabold !text-5xl !mb-[24px] !pl-[30px] !pr-[30px] text-gray-900">
          {heroContent.headline}
        </h1>

        {/* Subheadline */}
        <p className="md:text-xl max-w-3xl !text-2xl !mb-[40px] !pl-[30px] !pr-[30px] text-gray-600">
          {heroContent.subheadline}
        </p>

        {/* Clinic Image */}
        <div className="relative max-w-4xl mx-auto mb-10 rounded-2xl overflow-hidden shadow-2xl hover:shadow-[0_25px_60px_-15px_rgba(0,122,255,0.3)] transition-all duration-500 transform hover:-translate-y-1">
          <div className="aspect-video relative">
            <img
              src="https://customer-assets.emergentagent.com/job_8ad9161f-6cea-404b-9d6d-790d0e28c403/artifacts/rlxckl9h_2016-05-09-PHOTO-00005854%20%281%29.jpg"
              alt="Interior de clínica dental moderna"
              className="w-full h-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-t from-gray-900/60 via-transparent to-transparent"></div>
            
            {/* Caption */}
            <div className="absolute bottom-4 left-4 right-4">
              <span className="text-white font-medium text-sm md:text-base bg-black/30 backdrop-blur-sm px-4 py-2 rounded-full">
                Elimina hasta el 80% de las "sillas vacías"
              </span>
            </div>
          </div>
        </div>

        {/* CTAs */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-6">
          <a href={LINKS.calendar} target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto">
            <Button
              size="lg"
              className="w-full sm:w-auto bg-[#007AFF] hover:bg-[#0056b3] text-white px-8 py-6 text-lg font-semibold rounded-xl shadow-lg shadow-blue-500/25 hover:shadow-xl hover:shadow-blue-500/30 transition-all duration-300 hover:-translate-y-0.5">

              <Calendar className="w-5 h-5 mr-2" />
              {heroContent.ctaPrimary}
            </Button>
          </a>
        </div>

        <a
          href={LINKS.whatsapp}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 text-[#25D366] hover:text-[#128C7E] font-medium transition-colors duration-300 bg-green-50 px-5 py-2.5 rounded-full hover:bg-green-100">

          <MessageCircle className="w-5 h-5" />
          {heroContent.ctaSecondary}
        </a>

        {/* Trust indicators */}
        <div className="border-t border-gray-200/50 mt-12 pt-8">
          <p className="!text-lg mb-4 text-gray-500">Confianza de clínicas en toda España</p>
          <div className="flex items-center justify-center md:gap-10 !pr-[0px]">
            <div className="text-center px-4">
              <span className="block !font-bold !text-3xl text-gray-800">+120</span>
              <span className="!font-semibold !text-sm text-gray-500">Clínicas activas</span>
            </div>
            <div className="w-px h-12 bg-gray-200"></div>
            <div className="text-center px-4">
              <span className="block !font-bold !text-3xl text-[#007AFF]">85%</span>
              <span className="!font-semibold !text-sm text-gray-500">Reducción no visita</span>
            </div>
            <div className="w-px h-12 bg-gray-200"></div>
            <div className="text-center px-4">
              <span className="block !font-bold !text-3xl text-[#25D366]">4.9/5</span>
              <span className="!font-semibold !text-sm !text-center text-gray-500">Satisfacción</span>
            </div>
          </div>
        </div>
      </div>
    </section>);

};

export default HeroSection;